import { render, staticRenderFns } from "./cube-timer.vue?vue&type=template&id=8513e434&scoped=true&"
import script from "./cube-timer.vue?vue&type=script&lang=js&"
export * from "./cube-timer.vue?vue&type=script&lang=js&"
import style0 from "./cube-timer.vue?vue&type=style&index=0&id=8513e434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8513e434",
  null
  
)

export default component.exports